import { STATUSES } from 'constants/NotificationsConstants';
import * as types from 'modules/notifications/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {import('../../types.js').Notification} Notification */

/**
 * @typedef {{
 *   [id:string]: Notification
 * }} State
 */

/** @type {State} */
const initialState = {};

/**
 * @param {State} state
 * @param {import('../../types.js').FetchNotificationsActionSuccess} action
 * @returns {State}
 */
const update = (state, { payload }) => ({
  ...state,
  ...(payload.notifications?.reduce(
    (acc, notification) => ({
      ...acc,
      [notification.id]: {
        ...(state[notification.id] ?? {}),
        ...notification,
      },
    }),
    {}
  ) ?? {}),
});

/**
 * @param {State} state
 * @param {import('../../types.js').DeleteNotificationActionSuccess} action
 * @returns {State}
 */
const deleteOne = (state, { payload }) => {
  const { [payload.id]: notificationToDelete, ...newState } = state;
  return newState;
};

/**
 * @param {State} state
 * @param {import('../../types.js').MarkAsReadActionSuccess} action
 * @returns {State}
 */
const markAsRead = (state, { payload }) => ({
  ...state,
  ...(state[payload]
    ? {
      [payload]: {
        ...state[payload],
        status: STATUSES.READ,
      },
    }
    : {}),
});

/**
 * @param {State} state
 * @param {import('../../types.js').MarkAsUnreadActionSuccess} action
 * @returns {State}
 */
const markAsUnread = (state, { payload }) => ({
  ...state,
  ...(state[payload]
    ? {
      [payload]: {
        ...state[payload],
        status: STATUSES.UNREAD,
      },
    }
    : {}),
});

/**
 * @param {State} state
 * @param {import('../../types.js').MarkAllAsReadActionSuccess} action
 * @returns {State}
 */
const markAllAsRead = state =>
  Object.entries(state).reduce(
    (acc, [notificationId, notification]) => ({
      ...acc,
      [notificationId]: {
        ...notification,
        status: STATUSES.READ,
      },
    }),
    {}
  );

export default createReducer(initialState, {
  [types.ADD]: update,
  [types.FETCH_NOTIFICATIONS_SUCCESS]: update,
  [types.FETCH_NOTIFICATIONS_DASHBOARD_SUCCESS]: update,
  [types.FETCH_DROPDOWN_NOTIFICATIONS_SUCCESS]: update,
  [types.DELETE_NOTIFICATION_SUCCESS]: deleteOne,
  [types.MARK_AS_READ_SUCCESS]: markAsRead,
  [types.MARK_AS_UNREAD_SUCCESS]: markAsUnread,
  [types.MARK_ALL_AS_READ_SUCCESS]: markAllAsRead,
});
